import React from 'react';
import "../styles/App.scss";
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

function ProjectOptions(props){
    const {projectTitle, projectData} = props;
    return(
        <>
            <Accordion>
                <Button className="App-buttons">
                    <AccordionSummary
                        expandIcon={<ArrowDropDownIcon/>}
                        aria-controls="panel1a-content"
                        className="App-accordion"
                    >
                    {/* put the title here */}
                    {projectTitle}
                    </AccordionSummary>
                </Button>
                <AccordionDetails>
                    {/* put the options here     */}
                    <ul className="App-ul">
                        {projectData.map(item=>(
                            <li className="App-li">
                                <Link className="App-link" href={item.path}>
                                    {item.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                    
                </AccordionDetails>
            </Accordion>
        </>
    );
}

export default ProjectOptions;